// SKANDIA-kartplassering: koordinater for de svenske/danske hjemmevern-enhetene
// (stab-byer), koblet mot orbat-seed (SWE./DNK.). Gir COP et togglebart
// milsymbol-kartlag «SKANDIA-styrker». Koordinater er kjente by-/garnisonssteder
// (WGS84 [lon,lat]); avvik utenfor SE/DK-boksen flagges `suspect` (jf. J-5).
import { ORBAT_SEED } from './orbat-seed.js';
/** Stab-by → [lon, lat] (WGS84). Dedupliserte kjente steder. */
export const SKANDIA_TOWN = {
    // Sverige
    'Södertälje': [17.63, 59.20], 'Boden': [21.69, 65.83], 'Kiruna': [20.22, 67.85],
    'Umeå': [20.26, 63.83], 'Östersund': [14.64, 63.18], 'Härnösand': [17.94, 62.63],
    'Kungsängen': [17.76, 59.48], 'Falun': [15.63, 60.61], 'Gävle': [17.14, 60.67],
    'Enköping': [17.08, 59.64], 'Strängnäs': [17.03, 59.38], 'Haninge': [18.14, 59.17],
    'Karlstad': [13.50, 59.40], 'Örebro': [15.21, 59.27], 'Skövde': [13.85, 58.39],
    'Skredsvik': [11.55, 58.33], 'Göteborg': [11.97, 57.71], 'Halmstad': [12.86, 56.67],
    'Linköping': [15.62, 58.41], 'Eksjö': [14.97, 57.67], 'Kalmar': [16.36, 56.66],
    'Växjö': [14.81, 56.88], 'Karlskrona': [15.59, 56.16], 'Revingehed': [13.47, 55.70],
    'Malmö': [13.00, 55.61], 'Helsingborg': [12.69, 56.05], 'Rinkaby': [14.28, 55.98],
    'Visby': [18.29, 57.64],
    // Danmark
    'Skive': [9.03, 56.57], 'Nørresundby': [9.92, 57.06], 'Aarhus': [10.12, 56.16],
    'Vejle': [9.53, 55.71], 'Søgaard': [9.35, 54.93], 'Odense': [10.39, 55.40],
    'København': [12.59, 55.70], 'Ballerup': [12.36, 55.73], 'Fredensborg': [12.40, 55.97],
    'Gadstrup': [12.10, 55.57], 'Vordingborg': [11.91, 55.01], 'Rønne': [14.70, 55.10],
    'Frederikshavn': [10.54, 57.44], 'Korsør': [11.14, 55.33], 'Aalborg': [9.92, 57.05],
    'Roskilde': [12.09, 55.64], 'Karup': [9.17, 56.30], 'Skrydstrup': [9.26, 55.22],
};
/** Enhets-id → stab-by. Kobler orbat-seed til koordinat. */
export const SKANDIA_PLACE = {
    // Sverige — ledelse/regioner
    'SWE.HvSS': 'Södertälje', 'SWE.MRN': 'Boden', 'SWE.MRM': 'Kungsängen',
    'SWE.MRV': 'Skövde', 'SWE.MRS': 'Revingehed', 'SWE.P18': 'Visby',
    // Sverige — 40 bataljoner
    'SWE.hvbat10': 'Kiruna', 'SWE.hvbat11': 'Kiruna', 'SWE.hvbat12': 'Boden',
    'SWE.hvbat13': 'Umeå', 'SWE.hvbat14': 'Östersund', 'SWE.hvbat15': 'Härnösand',
    'SWE.hvbat16': 'Härnösand', 'SWE.hvbat17': 'Falun', 'SWE.hvbat18': 'Gävle',
    'SWE.hvbat21': 'Enköping', 'SWE.hvbat22': 'Enköping', 'SWE.hvbat23': 'Kungsängen',
    'SWE.hvbat24': 'Kungsängen', 'SWE.hvbat25': 'Kungsängen', 'SWE.hvbat26': 'Kungsängen',
    'SWE.hvbat27': 'Strängnäs', 'SWE.hvbat28': 'Haninge', 'SWE.hvbat29': 'Haninge',
    'SWE.hvbat19': 'Karlstad', 'SWE.hvbat20': 'Örebro', 'SWE.hvbat38': 'Skövde',
    'SWE.hvbat39': 'Skövde', 'SWE.hvbat40': 'Skredsvik', 'SWE.hvbat41': 'Göteborg',
    'SWE.hvbat42': 'Göteborg', 'SWE.hvbat43': 'Göteborg', 'SWE.hvbat44': 'Göteborg',
    'SWE.hvbat45': 'Halmstad', 'SWE.hvbat30': 'Linköping', 'SWE.hvbat31': 'Linköping',
    'SWE.hvbat33': 'Eksjö', 'SWE.hvbat34': 'Kalmar', 'SWE.hvbat35': 'Växjö',
    'SWE.hvbat36': 'Karlskrona', 'SWE.hvbat37': 'Karlskrona', 'SWE.hvbat46': 'Revingehed',
    'SWE.hvbat47': 'Malmö', 'SWE.hvbat48': 'Helsingborg', 'SWE.hvbat49': 'Rinkaby',
    'SWE.hvbat32': 'Visby',
    // Danmark — regioner + 12 distrikter + gren-eksempler
    'DNK.LRGVest': 'Skive', 'DNK.LRGOst': 'København',
    'DNK.Nordjylland': 'Nørresundby', 'DNK.MidtVestjylland': 'Skive', 'DNK.Ostjylland': 'Aarhus',
    'DNK.Sydostjylland': 'Vejle', 'DNK.SydSonderjylland': 'Søgaard', 'DNK.Fyn': 'Odense',
    'DNK.Kobenhavn': 'København', 'DNK.KobenhavnVestegn': 'Ballerup', 'DNK.Nordsjaelland': 'Fredensborg',
    'DNK.MidtVestsjaelland': 'Gadstrup', 'DNK.SydsjaellandLF': 'Vordingborg', 'DNK.Bornholm': 'Rønne',
    'DNK.Marine': 'København', 'DNK.Flyver': 'Karup',
    'DNK.HVF115': 'Frederikshavn', 'DNK.HVF124': 'Aarhus', 'DNK.HVF200': 'København',
    'DNK.HVF255': 'Korsør', 'DNK.HVF369': 'København',
    'DNK.HVE266': 'Aalborg', 'DNK.HVE270': 'Aalborg', 'DNK.HVE277': 'Karup', 'DNK.HVE284': 'Skrydstrup',
};
/** Grov SE/DK-boks (WGS84). */
function inBox(lon, lat) {
    return lat >= 54 && lat <= 69.5 && lon >= 8 && lon <= 24.5;
}
/** Bygg kart-plasseringer ved å koble orbat-seed (SWE./DNK.) med koordinater. */
export function skandiaPlacements() {
    const byId = new Map(ORBAT_SEED.map((u) => [u.id, u]));
    const out = [];
    for (const [id, town] of Object.entries(SKANDIA_PLACE)) {
        const u = byId.get(id);
        const c = SKANDIA_TOWN[town];
        if (!u || !c)
            continue;
        const [lon, lat] = c;
        out.push({
            id, name: u.name, sidc: u.sidc ?? '', nation: id.startsWith('SWE') ? 'SWE' : 'DNK',
            echelon: u.echelon, hq: u.hq ?? town, town, lon, lat, suspect: !inBox(lon, lat),
        });
    }
    return out;
}
/** Kun gyldige plasseringer (innenfor boksen). */
export function skandiaPlacementsValid() {
    return skandiaPlacements().filter((p) => !p.suspect);
}
//# sourceMappingURL=skandia-map.js.map